// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"150":"001d80c4a44098cbfa77","442":"db01b34550219c0ead6e","671":"d04d6ddd2919f74eb7fe"}[chunkId] + ".js";
};